export const emailValidate = value => {
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Please enter a valid email address';
  } else {
    return undefined;
  }
};

export const normalizePhone = value => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6,10)}`;
};

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLengthNorm = max => value => {
  return value.slice(0, max);
};

export const tubeIdNorm = max => value => {
  const regex = /[^a-zA-Z0-9-_]/gi;
  return value.replace(regex, '').slice(0, max);
};

export const alphaOnly = value => {
  const regex = /[^a-zA-Z -]/gi;
  return value.replace(regex, '');
};

export const alphaNumeric = value => {
  const regex = /[^a-zA-Z0-9-_]/gi;
  return value.replace(regex, '');
};

export const required = value => (value ? undefined : 'Required');

export const titleCase = str =>
  str.toLowerCase().replace(/\b\S/g, t => t.toUpperCase());

export const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const phoneValidate = value =>
  value && value.length < 12 ? `Must be a 10 digit phone number` : undefined;

export const pwValidate = value => (value.length >= 8) ? undefined : 'Password must be greater than eight characters';

export const confirmPassword = (value, { newPassword1 }) => value === newPassword1 ? undefined : 'Password does not match';

export const confirmEmail = (value, { email }) => value === email ? undefined : 'Email address does not match';

export const whitespaceValidate = (value) => value.trim() === value ? undefined :  'Spaces not permitted at beginning or end of password';
